module.exports = __webpack_public_path__ + "static/media/6b310c04-027c-4040-bb37-c701f399abf8.fa907f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/6b310c04-027c-4040-bb37-c701f399abf8.png
// module id = 1480
// module chunks = 0